/**
 * useValidateTransactionPending()
 *
 * Validates transaction is pending (not yet complete)
 * If not, log an error and navigate to the index page
 *
 * Used by most steps of donate journeys
 * ...to prevent them being accessed after the transaction is completed
 */
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/store/hooks';
import { logger } from '@/services/logger/logger';

export function useValidateTransactionPending() {
  // Takes value from state once (on load), do not re-render on state change (using `() => true` equality check as second argument)
  const completeState = useAppSelector(state => state.transaction.complete, () => true);

  const navigate = useNavigate();

  useEffect(() => {
    // If transaction is pending (as expected), do nothing
    if (!completeState) {
      return;
    }

    logger.error('Page inaccessible. Transaction is already complete.');
    void navigate('/');
  }, [completeState, navigate]);
}
